import { BreakpointObserver, Breakpoints, BreakpointState } from '@angular/cdk/layout';
import { Component, OnInit } from '@angular/core';
import { faAngleDown, faAngleRight, faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import { TrashService } from 'src/app/shared/services/trash.service';

@Component({
  selector: 'app-machine-part-info-trash',
  templateUrl: './machine-part-info-trash.component.html',
  styleUrl: './machine-part-info-trash.component.scss'
})
export class MachinePartInfoTrashComponent implements OnInit {
  faAngleDown = faAngleDown;
  faAngleRight = faAngleRight;
  faCircleInfo = faCircleInfo;
  isSmallScreen: boolean = false;
  isShowed: boolean[] = [];

  constructor(
    private _tSvc: TrashService,
    private readonly _breakpointObserver: BreakpointObserver,
  ) { }

  ngOnInit(): void {
    this._breakpointObserver
      .observe([Breakpoints.HandsetPortrait])
      .subscribe((state: BreakpointState) => {
        this.isSmallScreen = state.matches;
      });
  }

  public get TSvc(): TrashService {
    return this._tSvc;
  }

  show(rowIndex: number): void {
    this.isShowed[rowIndex] = !this.isShowed[rowIndex];
  }
}
